export const cooDashboardSourceHtml = String.raw`<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width,initial-scale=1">
<title>COO Operations Intelligence - Feb '26</title>
<style>
:root{
  --bg:#f0f2f5;--card:#fff;--header:#0f2044;--header2:#1a3a6e;
  --red:#ef4444;--orange:#f97316;--yellow:#eab308;--green:#22c55e;
  --blue:#3b82f6;--purple:#8b5cf6;--teal:#14b8a6;
  --txt:#1e293b;--sub:#64748b;--brd:#e2e8f0;
}
*{box-sizing:border-box;margin:0;padding:0}
body{font-family:'Segoe UI',system-ui,sans-serif;background:var(--bg);color:var(--txt);font-size:14px}
.header{background:linear-gradient(135deg,var(--header),var(--header2));color:#fff;padding:22px 32px;display:flex;justify-content:space-between;align-items:center}
.header h1{font-size:22px;font-weight:700}
.header h1 span{color:#93c5fd;font-size:14px;display:block;font-weight:400;margin-top:2px}
.header-right{text-align:right;font-size:12px;opacity:.8}
.data-pills{display:flex;gap:6px;flex-wrap:wrap;margin-top:8px}
.pill{background:rgba(255,255,255,.15);border:1px solid rgba(255,255,255,.3);border-radius:20px;padding:2px 10px;font-size:11px;color:#fff}
.alert-banner{background:linear-gradient(90deg,#92400e,#b45309);color:#fff;padding:10px 32px;font-size:12.5px;display:flex;align-items:center;gap:10px}
.domain-legend{display:flex;gap:12px;padding:12px 32px;background:#fff;border-bottom:2px solid var(--brd);flex-wrap:wrap}
.dleg{display:flex;align-items:center;gap:6px;font-size:12px;font-weight:500}
.dleg-dot{width:11px;height:11px;border-radius:50%}
.main{padding:20px 32px;max-width:1600px;margin:0 auto}
.kpi-section-label{font-size:11px;font-weight:700;color:var(--sub);text-transform:uppercase;letter-spacing:.8px;margin:18px 0 8px}
.kpi-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(175px,1fr));gap:10px;margin-bottom:4px}
.kpi-card{background:var(--card);border-radius:10px;padding:14px 16px;box-shadow:0 1px 4px rgba(0,0,0,.07);border-left:4px solid var(--blue);position:relative}
.kpi-card.red{border-left-color:var(--red)}.kpi-card.orange{border-left-color:var(--orange)}.kpi-card.green{border-left-color:var(--green)}.kpi-card.purple{border-left-color:var(--purple)}
.kpi-label{font-size:11px;color:var(--sub);font-weight:500;margin-bottom:6px}
.kpi-val{font-size:24px;font-weight:800;line-height:1}
.kpi-sub{font-size:11px;color:var(--sub);margin-top:4px}
.kpi-badge{position:absolute;top:10px;right:10px;font-size:10px;font-weight:700;padding:2px 7px;border-radius:20px;background:#fee2e2;color:#b91c1c}
.kpi-badge.ok{background:#dcfce7;color:#15803d}.kpi-badge.warn{background:#fef3c7;color:#92400e}
.domain-tag{font-size:10px;font-weight:700;color:var(--sub);text-transform:uppercase;letter-spacing:.5px;margin-bottom:4px}
.circle-tabs{display:flex;gap:8px;margin:24px 0 0;border-bottom:2px solid var(--brd);padding-bottom:0}
.circle-tab{padding:10px 22px;border-radius:8px 8px 0 0;font-size:13px;font-weight:700;cursor:pointer;background:var(--card);border:2px solid var(--brd);border-bottom:none;color:var(--sub);transition:.2s;position:relative;top:2px}
.circle-tab.active{color:#fff;border-bottom:none}
.circle-tab.HP.active{background:#2563eb;border-color:#2563eb}
.circle-tab.JA.active{background:#dc2626;border-color:#dc2626}
.circle-tab.KS.active{background:#7c3aed;border-color:#7c3aed}
.circle-tab.UW.active{background:#d97706;border-color:#d97706}
.tab-score{display:block;font-size:10px;font-weight:400;opacity:.85;margin-top:2px}
.circle-panel{display:none}.circle-panel.active{display:block}
.circle-hdr{border-radius:0;padding:16px 22px;color:#fff;display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:10px}
.circle-hdr.HP{background:linear-gradient(90deg,#1d4ed8,#2563eb)}
.circle-hdr.JA{background:linear-gradient(90deg,#b91c1c,#dc2626)}
.circle-hdr.KS{background:linear-gradient(90deg,#6d28d9,#7c3aed)}
.circle-hdr.UW{background:linear-gradient(90deg,#b45309,#d97706)}
.circle-hdr h2{font-size:17px;font-weight:700}
.score-badges{display:flex;gap:8px;flex-wrap:wrap}
.sbadge{background:rgba(255,255,255,.2);border:1px solid rgba(255,255,255,.4);border-radius:8px;padding:6px 12px;font-size:12px;font-weight:700;text-align:center}
.sbadge small{display:block;font-size:10px;font-weight:400;opacity:.8;margin-bottom:2px}
.domain-section{background:var(--card);margin-bottom:3px;overflow:hidden;box-shadow:0 1px 4px rgba(0,0,0,.05)}
.domain-section:last-child{border-radius:0 0 10px 10px;margin-bottom:20px}
.domain-section-hdr{padding:9px 18px;font-size:12px;font-weight:700;letter-spacing:.3px;display:flex;align-items:center;gap:8px;color:#fff}
.domain-section-hdr.fiber{background:linear-gradient(90deg,#1e3a8a,#1d4ed8)}
.domain-section-hdr.tower{background:linear-gradient(90deg,#374151,#4b5563)}
.domain-section-hdr.osc{background:linear-gradient(90deg,#0c4a6e,#0369a1)}
.domain-section-hdr.mfl{background:linear-gradient(90deg,#4c1d95,#6d28d9)}
.domain-section-hdr.pm-fiber{background:linear-gradient(90deg,#064e3b,#065f46)}
.domain-section-hdr.pm-tower{background:linear-gradient(90deg,#1c1917,#44403c)}
.domain-section-hdr.pm-osc{background:linear-gradient(90deg,#7f1d1d,#991b1b)}
.domain-section-hdr.pm-mfl{background:linear-gradient(90deg,#312e81,#3730a3)}
.domain-section-body{padding:14px 18px}
.insight-card{border-radius:8px;border-top:4px solid var(--red);background:#fff;box-shadow:0 1px 5px rgba(0,0,0,.08);margin-bottom:12px}
.insight-card.orange{border-top-color:var(--orange)}.insight-card.yellow{border-top-color:var(--yellow)}.insight-card.green{border-top-color:var(--green)}.insight-card.purple{border-top-color:var(--purple)}
.insight-card-body{padding:12px 16px}
.insight-title{font-size:13px;font-weight:700;margin-bottom:4px}
.exposure{font-size:20px;font-weight:900;color:var(--red);margin:6px 0}
.exposure.orange{color:var(--orange)}.exposure.yellow{color:var(--yellow)}.exposure.purple{color:var(--purple)}
.insight-text{font-size:12.5px;color:var(--txt);line-height:1.55;margin-bottom:8px}
.action-box{background:#eff6ff;border-left:3px solid var(--blue);padding:8px 12px;border-radius:0 4px 4px 0;font-size:12px;color:#1e40af}
.action-box strong{display:block;font-size:11px;text-transform:uppercase;letter-spacing:.5px;margin-bottom:2px;color:#1d4ed8}
.insight-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(300px,1fr));gap:12px}
.two-col{display:grid;grid-template-columns:1fr 1fr;gap:14px}
@media(max-width:900px){.two-col{grid-template-columns:1fr}}
.mp-table{width:100%;border-collapse:collapse;font-size:12px;margin-bottom:12px}
.mp-table th{background:#f8fafc;padding:6px 10px;text-align:left;border-bottom:2px solid var(--brd);font-weight:700;color:var(--sub);font-size:11px}
.mp-table td{padding:6px 10px;border-bottom:1px solid #f1f5f9}
.mp-table tr:last-child td{border-bottom:none}
.mp-table tr:hover td{background:#f8fafc}
.tag-red{background:#fee2e2;color:#b91c1c;border-radius:4px;padding:1px 7px;font-size:11px;font-weight:700;white-space:nowrap}
.tag-orange{background:#ffedd5;color:#9a3412;border-radius:4px;padding:1px 7px;font-size:11px;font-weight:700}
.tag-yellow{background:#fefce8;color:#854d0e;border-radius:4px;padding:1px 7px;font-size:11px;font-weight:700}
.tag-green{background:#dcfce7;color:#15803d;border-radius:4px;padding:1px 7px;font-size:11px;font-weight:700}
.action-plan{background:var(--card);border-radius:12px;box-shadow:0 2px 8px rgba(0,0,0,.06);overflow:hidden;margin-top:28px}
.action-plan-hdr{background:var(--header);color:#fff;padding:14px 24px;font-size:14px;font-weight:700}
.action-plan table{width:100%;border-collapse:collapse}
.action-plan th{background:#f8fafc;padding:9px 14px;text-align:left;font-size:11px;font-weight:700;color:var(--sub);border-bottom:2px solid var(--brd)}
.action-plan td{padding:9px 14px;border-bottom:1px solid var(--brd);font-size:12px;vertical-align:top}
.action-plan tr:last-child td{border-bottom:none}
.action-plan tr:hover td{background:#f8fafc}
.p-tag{display:inline-block;border-radius:4px;padding:2px 8px;font-size:11px;font-weight:800}
.p1{background:#fee2e2;color:#b91c1c}.p2{background:#ffedd5;color:#9a3412}.p3{background:#fefce8;color:#854d0e}
.dom-chip{display:inline-block;border-radius:20px;padding:2px 8px;font-size:10px;font-weight:700;margin-right:3px;margin-bottom:2px}
.dom-fiber{background:#dbeafe;color:#1d4ed8}.dom-tower{background:#e5e7eb;color:#374151}.dom-osc{background:#e0f2fe;color:#0369a1}.dom-mfl{background:#ede9fe;color:#6d28d9}.dom-pm{background:#d1fae5;color:#065f46}
.footer{text-align:center;padding:20px;color:var(--sub);font-size:11px;background:#fff;border-top:1px solid var(--brd);margin-top:32px}
</style>
</head>
<body>

<div class="header">
  <div>
    <h1>COO Operations Intelligence Dashboard
      <span>February 2026 · All Domains · AI-Generated Analysis</span>
    </h1>
    <div class="data-pills">
      <span class="pill">📡 Fiber CM/PM</span>
      <span class="pill">🗼 Tower CM/PM (21,129 sites)</span>
      <span class="pill">📶 OSC/Small Cell CM/PM (7,215 sites)</span>
      <span class="pill">🔗 MFL CM/PM (308 sites)</span>
      <span class="pill">🏗 Standalone CM/PM (62 sites)</span>
      <span class="pill">📡 FTTX CM/PM</span>
    </div>
  </div>
  <div class="header-right">
    <div style="font-size:18px;font-weight:800">4 Circles · 14 MPs</div>
    <div>HP · JA · KS · UW</div>
    <div style="margin-top:4px;opacity:.7">Generated: March 2026</div>
  </div>
</div>

<div class="alert-banner">
  <span>⚠️</span>
  <strong>Partial Data:</strong> Manpower availability (splicer/labour/vehicle) not yet received for Feb'26. All other domains fully included.
</div>

<div class="domain-legend">
  <span style="font-size:11px;font-weight:700;color:var(--sub);margin-right:4px">DOMAINS:</span>
  <div class="dleg"><div class="dleg-dot" style="background:#1d4ed8"></div>Fiber CM/PM</div>
  <div class="dleg"><div class="dleg-dot" style="background:#4b5563"></div>Tower CM/PM</div>
  <div class="dleg"><div class="dleg-dot" style="background:#0369a1"></div>OSC/Small Cell CM/PM</div>
  <div class="dleg"><div class="dleg-dot" style="background:#6d28d9"></div>MFL/Standalone CM/PM</div>
  <div class="dleg"><div class="dleg-dot" style="background:#14b8a6"></div>FTTX CM/PM</div>
  <div style="margin-left:auto;font-size:11px;color:var(--sub)">Red border = critical · Orange = warning · Green = OK</div>
</div>

<div class="main">

<div class="kpi-section-label">📊 CM Performance - Zone Summary (All Domains)</div>
<div class="kpi-grid">
  <div class="kpi-card red">
    <div class="domain-tag">Fiber CM</div>
    <div class="kpi-label">Zone Avg Score</div>
    <div class="kpi-val" style="color:var(--red)">~40<small style="font-size:14px">/100</small></div>
    <div class="kpi-sub">All 14 MPs penalised</div>
    <div class="kpi-badge">CRITICAL</div>
  </div>
  <div class="kpi-card red">
    <div class="domain-tag">Tower CM</div>
    <div class="kpi-label">Zone Avg KPI Score</div>
    <div class="kpi-val" style="color:var(--red)">10<small style="font-size:14px">/100</small></div>
    <div class="kpi-sub">Hapur=0 · Jammu=5</div>
    <div class="kpi-badge">CRITICAL</div>
  </div>
  <div class="kpi-card red">
    <div class="domain-tag">OSC/Small Cell CM</div>
    <div class="kpi-label">Avg SC Availability</div>
    <div class="kpi-val" style="color:var(--red)">93.0<small style="font-size:14px">%</small></div>
    <div class="kpi-sub">Target ≥99.95% · All MPs failing</div>
    <div class="kpi-badge">CRITICAL</div>
  </div>
  <div class="kpi-card orange">
    <div class="domain-tag">MFL CM</div>
    <div class="kpi-label">Zone Avg KPI</div>
    <div class="kpi-val" style="color:var(--orange)">81<small style="font-size:14px">%</small></div>
    <div class="kpi-sub">HP worst 70.4% · KS best 92%</div>
    <div class="kpi-badge warn">WARN</div>
  </div>
  <div class="kpi-card orange">
    <div class="domain-tag">Standalone CM</div>
    <div class="kpi-label">Zone Avg KPI</div>
    <div class="kpi-val" style="color:var(--orange)">71<small style="font-size:14px">%</small></div>
    <div class="kpi-sub">HP worst 62.5%</div>
    <div class="kpi-badge warn">WARN</div>
  </div>
  <div class="kpi-card" style="border-left-color:var(--green)">
    <div class="domain-tag">FTTX OLT CM</div>
    <div class="kpi-label">OLT Availability</div>
    <div class="kpi-val" style="color:var(--green)">99.97<small style="font-size:14px">%</small></div>
    <div class="kpi-sub">Meets SLA zone-wide</div>
    <div class="kpi-badge ok">GOOD</div>
  </div>
</div>

<div class="kpi-section-label">📋 PM Compliance - Zone Summary (All Domains)</div>
<div class="kpi-grid">
  <div class="kpi-card orange">
    <div class="domain-tag">Fiber PM</div>
    <div class="kpi-label">Billing Rate (Zone)</div>
    <div class="kpi-val" style="color:var(--orange)">85.3<small style="font-size:14px">%</small></div>
    <div class="kpi-sub">6,048 KM non-billable · ↓91.3% Dec</div>
    <div class="kpi-badge warn">DECLINING</div>
  </div>
  <div class="kpi-card red">
    <div class="domain-tag">OSC PM</div>
    <div class="kpi-label">OSC PM Completion</div>
    <div class="kpi-val" style="color:var(--red)">51<small style="font-size:14px">%</small></div>
    <div class="kpi-sub">UW all MPs 34-46% · CRISIS</div>
    <div class="kpi-badge">CRISIS</div>
  </div>
  <div class="kpi-card orange">
    <div class="domain-tag">Tower PM</div>
    <div class="kpi-label">TECO Completion</div>
    <div class="kpi-val" style="color:var(--orange)">92.7<small style="font-size:14px">%</small></div>
    <div class="kpi-sub">Hapur=83.8% · Bareilly=87.3%</div>
    <div class="kpi-badge warn">BELOW TARGET</div>
  </div>
  <div class="kpi-card red">
    <div class="domain-tag">Standalone PM</div>
    <div class="kpi-label">TECO Done</div>
    <div class="kpi-val" style="color:var(--red)">~55<small style="font-size:14px">%</small></div>
    <div class="kpi-sub">Kangra/Shimla/Srinagar = 0%</div>
    <div class="kpi-badge">CRISIS</div>
  </div>
  <div class="kpi-card" style="border-left-color:var(--green)">
    <div class="domain-tag">MFL PM</div>
    <div class="kpi-label">MFL Completion</div>
    <div class="kpi-val" style="color:var(--green)">99.0<small style="font-size:14px">%</small></div>
    <div class="kpi-sub">Minor gaps in 3 MPs only (305/308)</div>
    <div class="kpi-badge ok">GOOD</div>
  </div>
  <div class="kpi-card orange">
    <div class="domain-tag">FTTX PM</div>
    <div class="kpi-label">Completion</div>
    <div class="kpi-val" style="color:var(--orange)">97.9<small style="font-size:14px">%</small></div>
    <div class="kpi-sub">UW=96% · Aligarh=77.1%</div>
    <div class="kpi-badge warn">WATCH</div>
  </div>
</div>

<div class="circle-tabs">
  <div class="circle-tab HP active" onclick="setTab('HP')">HP - Himachal Pradesh
    <span class="tab-score">MFL 70.4% · Standalone 62.5% · Standalone PM 0%</span>
  </div>
  <div class="circle-tab JA" onclick="setTab('JA')">JA - Jammu
    <span class="tab-score">Tower 5/100 · Fiber PM 74.1% · 2X: 714 KM</span>
  </div>
  <div class="circle-tab KS" onclick="setTab('KS')">KS - Srinagar
    <span class="tab-score">OSC Alarms 31% · Standalone PM 0%</span>
  </div>
  <div class="circle-tab UW" onclick="setTab('UW')">UW - UP West
    <span class="tab-score">Hapur Tower 0/100 · OSC PM 34-46% · SC Avail 78.9%</span>
  </div>
</div>

<!-- ===== HP PANEL ===== -->
<div class="circle-panel HP active" id="panel-HP">
  <div class="circle-hdr HP">
    <div><h2>HP · Himachal Pradesh - Worst Issues Feb '26</h2>
    <div style="font-size:12px;opacity:.85;margin-top:4px">MPs: Kangra · Mandi · Shimla</div></div>
    <div class="score-badges">
      <div class="sbadge"><small>Tower CM</small>15/100</div>
      <div class="sbadge"><small>MFL CM</small>70.4% 🔴</div>
      <div class="sbadge"><small>Standalone CM</small>62.5% 🔴</div>
      <div class="sbadge"><small>Fiber PM</small>74.5-81.4%</div>
      <div class="sbadge"><small>Shimla 2X Risk</small>352 KM</div>
      <div class="sbadge"><small>Standalone PM</small>0% Kangra+Shimla</div>
    </div>
  </div>

  <div class="domain-section">
    <div class="domain-section-hdr tower">🗼 Tower CM - DG &amp; NWA Failures Across All HP MPs</div>
    <div class="domain-section-body">
      <table class="mp-table">
        <tr><th>MP</th><th>eNodeB NWA</th><th>SA Alarms ≤4h</th><th>Non-SA ≤24h</th><th>DG Start %</th><th>KPI Score</th></tr>
        <tr><td><b>Kangra</b></td><td>99.84% <span class="tag-red">BELOW</span></td><td>77% <span class="tag-red">FAIL</span></td><td>98.7%</td><td>77% <span class="tag-red">FAIL</span></td><td><span class="tag-orange">15/100</span></td></tr>
        <tr><td><b>Mandi</b></td><td>99.58% <span class="tag-red">BELOW</span></td><td>79% <span class="tag-red">FAIL</span></td><td>95.4% <span class="tag-orange">LOW</span></td><td>69% <span class="tag-red">FAIL</span></td><td><span class="tag-orange">15/100</span></td></tr>
        <tr><td><b>Shimla</b></td><td>99.76% <span class="tag-red">BELOW</span></td><td>75% <span class="tag-red">FAIL</span></td><td>98.7%</td><td>73% <span class="tag-red">FAIL</span></td><td><span class="tag-orange">15/100</span></td></tr>
      </table>
      <div class="insight-card orange">
        <div class="insight-card-body">
          <div class="insight-title">⚡ DG Failure - Systemic Across All HP MPs (69-77% Start Rate)</div>
          <div class="exposure orange">69-77% DG Start Rate vs 100% Target</div>
          <div class="insight-text">All three HP MPs fail DG start test. Mandi worst at 69% - 31% of DGs may fail during power outages. eNodeB NWA below 99.99% target everywhere. SA alarm resolution 75-79% (target 100%). Mandi Non-SA at 95.4% (target 99%) is particularly concerning for chronic alarm backlog.</div>
          <div class="action-box"><strong>Action Required</strong>HP-wide DG health audit. Battery + SMPS checks. Mandi Non-SA alarm clearance drive. DG maintenance schedule revision.</div>
        </div>
      </div>
    </div>
  </div>

  <div class="domain-section">
    <div class="domain-section-hdr mfl">🔗 MFL + Standalone CM - HP Worst in Zone Both Domains</div>
    <div class="domain-section-body">
      <div class="two-col">
        <div class="insight-card red">
          <div class="insight-card-body">
            <div class="insight-title">📉 MFL CM: HP = 70.4% - Lowest Circle in Zone</div>
            <div class="exposure">5.6% Avg Penalty · 71 Sites · SLA Deduction 2.376</div>
            <div class="insight-text">HP MFL averages 70.4% KPI score - worst circle in zone (KS best at 92%). Penalty rate 5.6% per site. Multiple sites in sub-60% band triggering maximum penalty. Issues stem from outage KPI + energy parameter non-compliance.</div>
            <div class="action-box"><strong>Action</strong>Site-by-site MFL audit. Sub-60% sites first. Outage + energy parameter deep-dive.</div>
          </div>
        </div>
        <div class="insight-card red">
          <div class="insight-card-body">
            <div class="insight-title">🏗 Standalone CM: HP = 62.5% - Worst Zone</div>
            <div class="exposure">62.5% KPI · SLA Penalty 0.315 · 8 Sites</div>
            <div class="insight-text">8 HP Standalone AG1 sites average 62.5% KPI - worst in zone. JA close at 64.4%. Energy parameter and outage score failures mirror MFL pattern, suggesting zone-wide power infrastructure deficiency in HP.</div>
            <div class="action-box"><strong>Action</strong>Standalone PM audit. Zabbix visibility check for all 8 HP sites. Energy parameter reporting verification.</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="domain-section">
    <div class="domain-section-hdr pm-fiber">📋 Fiber PM - 2X Escalation Risk</div>
    <div class="domain-section-body">
      <table class="mp-table">
        <tr><th>MP</th><th>Billing Rate</th><th>NB KM</th><th>2X Risk KM</th><th>2X % of NB</th><th>Intra Miss</th></tr>
        <tr><td><b>Kangra</b></td><td>79.0%</td><td>533 KM</td><td>217 KM</td><td>40.7%</td><td>0.4%</td></tr>
        <tr><td><b>Mandi</b></td><td>74.5%</td><td>452 KM</td><td>262 KM</td><td>58.0%</td><td>31.9% <span class="tag-red">HIGH</span></td></tr>
        <tr><td><b>Shimla</b></td><td>81.4%</td><td>469 KM</td><td>352 KM</td><td>75.0% <span class="tag-red">CRITICAL</span></td><td>9.3%</td></tr>
      </table>
      <div class="insight-grid">
        <div class="insight-card red">
          <div class="insight-card-body">
            <div class="insight-title">🔴 Shimla 2X Crisis - 352 KM Consecutive Fails</div>
            <div class="exposure">352 KM = 75% of NB is 2X</div>
            <div class="insight-text">352 KM failed BOTH Jan and Feb PM. These become double-penalty 2X deductions in March billing if unresolved. Shimla's billing rate (81.4%) masks this larger risk. Worst 2X ratio in zone.</div>
            <div class="action-box"><strong>March Deadline - Urgent</strong>Execute PM on all 352 KM before March billing close. Aerial routes first. Daily tracker required.</div>
          </div>
        </div>
        <div class="insight-card orange">
          <div class="insight-card-body">
            <div class="insight-title">📉 Mandi Worst HP Billing at 74.5%</div>
            <div class="exposure">452 KM NB · 262 KM 2X Risk</div>
            <div class="insight-text">Mandi has highest intracity miss (31.9%) and second-worst billing in HP. Both intercity (24.7%) and intracity miss rates elevated. 262 KM at 2X risk.</div>
            <div class="action-box"><strong>Action</strong>Mandi intracity patrolling audit. Physical completion verification vs paper records.</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="domain-section">
    <div class="domain-section-hdr pm-mfl">🏗 Standalone PM - Kangra &amp; Shimla = 0% TECO</div>
    <div class="domain-section-body">
      <div class="insight-card red">
        <div class="insight-card-body">
          <div class="insight-title">🚨 Kangra (2 sites) &amp; Shimla (6 sites) - Zero TECO Executed</div>
          <div class="exposure">8 Sites · 0 TECO Completed · Feb Billing at Risk</div>
          <div class="insight-text">WOs raised for all 8 sites but TECO not performed. This is complete non-compliance for Feb PM billing. Srinagar (KS) is also at 0% (4 sites). Three circles with unexecuted standalone TECO. Agra (UW) 75% done, Muzaffarnagar 29%.</div>
          <div class="action-box"><strong>Immediate Action</strong>Schedule TECO visits for Kangra and Shimla standalone sites. Physical completion confirmation + system update required.</div>
        </div>
      </div>
    </div>
  </div>

  <div class="domain-section">
    <div class="domain-section-hdr pm-osc">📶 OSC PM - Moderate Shortfall</div>
    <div class="domain-section-body">
      <table class="mp-table">
        <tr><th>MP</th><th>Total OSC Sites</th><th>PM Done</th><th>Completion</th><th>Status</th></tr>
        <tr><td>Kangra</td><td>356</td><td>224</td><td>62.9%</td><td><span class="tag-orange">BELOW</span></td></tr>
        <tr><td>Mandi</td><td>290</td><td>220</td><td>75.9%</td><td><span class="tag-yellow">PARTIAL</span></td></tr>
        <tr><td>Shimla</td><td>476</td><td>391</td><td>82.1%</td><td><span class="tag-yellow">PARTIAL</span></td></tr>
      </table>
      <p style="font-size:12px;color:var(--sub)">HP is comparatively better than UW on OSC PM but all MPs still below expected completion. Kangra needs attention at 62.9%.</p>
    </div>
  </div>

  <div class="domain-section">
    <div class="domain-section-hdr tower">🗼 Tower PM - HP</div>
    <div class="domain-section-body">
      <table class="mp-table">
        <tr><th>MP</th><th>Scope</th><th>TECO Done</th><th>Completion</th><th>Non-TECO Fails</th></tr>
        <tr><td>Kangra</td><td>1,513</td><td>1,438</td><td>95.0%</td><td>36</td></tr>
        <tr><td>Shimla</td><td>1,191</td><td>1,125</td><td>94.5%</td><td>39</td></tr>
        <tr><td>Mandi</td><td>788</td><td>739</td><td>93.8%</td><td>40</td></tr>
      </table>
      <p style="font-size:12px;color:var(--sub)">HP Tower PM in 93-95% range - acceptable but with room to improve. Mandi Non-SA visibility failures (9 sites) should be resolved.</p>
    </div>
  </div>
</div>

<!-- ===== JA PANEL ===== -->
<div class="circle-panel JA" id="panel-JA">
  <div class="circle-hdr JA">
    <div><h2>JA · Jammu - Worst Issues Feb '26</h2>
    <div style="font-size:12px;opacity:.85;margin-top:4px">MP: Jammu</div></div>
    <div class="score-badges">
      <div class="sbadge"><small>Fiber CM</small>10 Inter / 30 Intra</div>
      <div class="sbadge"><small>Tower CM</small>5/100 🔴</div>
      <div class="sbadge"><small>MFL CM</small>79%</div>
      <div class="sbadge"><small>Fiber PM Billing</small>74.1% 🔴</div>
      <div class="sbadge"><small>2X Risk</small>714 KM 🔴</div>
      <div class="sbadge"><small>OSC PM</small>70.7%</div>
    </div>
  </div>

  <div class="domain-section">
    <div class="domain-section-hdr tower">🗼 Tower CM - 5/100 (2nd Worst Zone)</div>
    <div class="domain-section-body">
      <table class="mp-table">
        <tr><th>KPI Parameter</th><th>Jammu</th><th>Target</th><th>Score</th></tr>
        <tr><td>eNodeB NWA</td><td>99.197%</td><td>≥99.99%</td><td><span class="tag-red">0 pts</span></td></tr>
        <tr><td>Infra Uptime</td><td>99.829%</td><td>≥99.999%</td><td><span class="tag-red">0 pts</span></td></tr>
        <tr><td>SA Alarms ≤4h</td><td>74%</td><td>100%</td><td><span class="tag-red">0 pts</span></td></tr>
        <tr><td>Non-SA Alarms ≤24h</td><td>87.73%</td><td>≥99%</td><td><span class="tag-yellow">5 pts</span></td></tr>
        <tr><td>DG Failed to Start</td><td>66.0%</td><td>100%</td><td><span class="tag-red">0 pts</span></td></tr>
        <tr><td><strong>TOTAL</strong></td><td colspan="2">Scope: 2,278 sites</td><td><span class="tag-red"><strong>5/100</strong></span></td></tr>
      </table>
      <div class="insight-card red">
        <div class="insight-card-body">
          <div class="insight-title">🚨 Tower KPI 5/100 - 34% of Jammu DGs at Failure Risk</div>
          <div class="exposure">2,278 Tower Sites · Near-Zero KPI</div>
          <div class="insight-text">Jammu Tower CM scores 5/100 - 4 of 5 KPI parameters scored zero. With 2,278 sites, the non-SA alarm backlog at 87.7% (target 99%) represents hundreds of unresolved chronic alarms. DG start rate 66% means 770+ DGs may fail during J&K winter power outages - a critical reliability risk.</div>
          <div class="action-box"><strong>Urgent - 14 Days</strong>DG functional audit across Jammu. Alarm clearance task force. Infra uptime check on bottom-quintile sites.</div>
        </div>
      </div>
    </div>
  </div>

  <div class="domain-section">
    <div class="domain-section-hdr fiber">📡 Fiber CM - Worst FTKM &amp; MTTR in Zone</div>
    <div class="domain-section-body">
      <div class="insight-grid">
        <div class="insight-card red">
          <div class="insight-card-body">
            <div class="insight-title">📡 FTKM 25.6 KM/Fault - Worst Zone · 146 Faults</div>
            <div class="exposure">25.6 KM per fault · MTTR 8.8h Inter</div>
            <div class="insight-text">Jammu has worst Fault-to-KM ratio (25.6 KM/fault) and worst intercity MTTR (8.8h). 146 total faults in Feb (71 intercity + 75 intracity). KPI: Intercity=10/100, Intracity=30/100 - both heavily penalised.</div>
            <div class="action-box"><strong>Action</strong>Top-20 repeat fault site RCA. MTTR event analysis - mobilisation time, spares availability.</div>
          </div>
        </div>
        <div class="insight-card orange">
          <div class="insight-card-body">
            <div class="insight-title">🌡 High Fault Density - 146 Faults vs Zone Avg ~70</div>
            <div class="exposure">146 Faults in Feb Alone</div>
            <div class="insight-text">Jammu has the highest fault count in zone, approximately double the zone average. Combined with slow restoration (8.8h MTTR), P1 resources are overstretched. Network age and terrain are compounding factors.</div>
            <div class="action-box"><strong>Action</strong>Dedicated P1 response team for Jammu. Intracity SLA clock monitoring. Consider route condition surveys for high-FTKM segments.</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="domain-section">
    <div class="domain-section-hdr pm-fiber">📋 Fiber PM - Worst Billing in Zone + Massive 2X Risk</div>
    <div class="domain-section-body">
      <div class="insight-grid">
        <div class="insight-card red">
          <div class="insight-card-body">
            <div class="insight-title">🔴 74.1% Billing - Worst in Zone · ↑ NB from 704→995 KM</div>
            <div class="exposure">995 KM Non-Billable · +41% from Dec</div>
            <div class="insight-text">Jammu is worst Fiber PM billing MP in zone. NB KM grew +41% from Dec (704 KM) to Feb (995 KM). Intercity miss 30.1%, intracity miss 15.0%. Deterioration trend is accelerating, not stabilising.</div>
            <div class="action-box"><strong>Action</strong>Immediate PM catch-up plan. Identify patroller-to-scope assignment gaps. Supervisor field audit.</div>
          </div>
        </div>
        <div class="insight-card red">
          <div class="insight-card-body">
            <div class="insight-title">⚠️ 714 KM at 2X Risk - Largest Absolute in Zone</div>
            <div class="exposure">714 KM = 72% of NB is Consecutive Fail</div>
            <div class="insight-text">714 KM failed both Jan and Feb PM - if not done by March billing close, all 714 KM become double-penalty deductions. This is the highest 2X risk in absolute KM terms in the zone. Financial exposure is substantial.</div>
            <div class="action-box"><strong>Critical - March Deadline</strong>714 KM MUST be PM'd before March billing. Daily progress dashboard. Circle head accountability required.</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="domain-section">
    <div class="domain-section-hdr pm-tower">🗼 Tower PM - Jammu</div>
    <div class="domain-section-body">
      <table class="mp-table">
        <tr><th>Metric</th><th>Value</th><th>Note</th></tr>
        <tr><td>Total Scope</td><td>2,278 sites</td><td></td></tr>
        <tr><td>TECO Done</td><td>2,100 (92.2%)</td><td><span class="tag-yellow">BELOW TARGET</span></td></tr>
        <tr><td>Non-TECO Fails</td><td>67 sites</td><td>Stage-1 failure</td></tr>
        <tr><td>Zabbix Visibility Fail</td><td>111 sites</td><td><span class="tag-orange">HIGH - Monitoring gap</span></td></tr>
      </table>
      <p style="font-size:12px;color:var(--sub)">111 Zabbix visibility failures means these sites are not monitored in real-time - compounding the alarm backlog problem seen in CM KPIs.</p>
    </div>
  </div>

  <div class="domain-section">
    <div class="domain-section-hdr osc">📶 OSC CM - Alarm Response Very Poor</div>
    <div class="domain-section-body">
      <table class="mp-table">
        <tr><th>KPI</th><th>Jammu Value</th><th>Target</th><th>Status</th></tr>
        <tr><td>Small Cell Availability</td><td>94.85%</td><td>≥99.95%</td><td><span class="tag-red">FAIL</span></td></tr>
        <tr><td>SA Alarms Resolved ≤4h</td><td>38%</td><td>100%</td><td><span class="tag-red">CRITICAL</span></td></tr>
        <tr><td>UBR RSL Degraded ≤24h</td><td>1 case</td><td>≤24</td><td><span class="tag-green">OK</span></td></tr>
      </table>
    </div>
  </div>
</div>

<!-- ===== KS PANEL ===== -->
<div class="circle-panel KS" id="panel-KS">
  <div class="circle-hdr KS">
    <div><h2>KS · Srinagar - Worst Issues Feb '26</h2>
    <div style="font-size:12px;opacity:.85;margin-top:4px">MP: Srinagar</div></div>
    <div class="score-badges">
      <div class="sbadge"><small>Fiber CM</small>70 Inter / 45 Intra ✅</div>
      <div class="sbadge"><small>Tower CM</small>25/100 (Best Zone)</div>
      <div class="sbadge"><small>MFL CM</small>92% 🟢</div>
      <div class="sbadge"><small>OSC Alarm Res.</small>31% 🔴</div>
      <div class="sbadge"><small>Standalone PM</small>0% TECO</div>
      <div class="sbadge"><small>Tower PM</small>91.4% (Worst Zone)</div>
    </div>
  </div>

  <div class="domain-section">
    <div class="domain-section-hdr osc">📶 OSC/Small Cell CM - Alarm Response = Worst in Entire Zone</div>
    <div class="domain-section-body">
      <table class="mp-table">
        <tr><th>KPI</th><th>Srinagar</th><th>Target</th><th>Status</th></tr>
        <tr><td>Small Cell Availability</td><td>95.35%</td><td>≥99.95%</td><td><span class="tag-red">FAIL</span></td></tr>
        <tr><td>SA Alarms Resolved ≤4h</td><td>31%</td><td>100%</td><td><span class="tag-red">WORST ZONE</span></td></tr>
        <tr><td>UBR RSL Degraded ≤24h</td><td>6 cases</td><td>≤24</td><td><span class="tag-yellow">WATCH</span></td></tr>
        <tr><td>SMPS Unreachable ≤4h</td><td>175 cases</td><td>≤2,125</td><td><span class="tag-green">OK</span></td></tr>
      </table>
      <div class="insight-card red">
        <div class="insight-card-body">
          <div class="insight-title">🚨 31% SA Alarm Resolution - Worst Zone · 69% Alarms Unresolved Within SLA</div>
          <div class="exposure">31% vs 100% Target</div>
          <div class="insight-text">Srinagar has the worst service-affecting small cell alarm resolution rate in the zone. 69% of service-affecting alarms go beyond the 4-hour SLA. Availability at 95.35% is 4.6 points below SLA target. UBR RSL degraded cases (6) are highest among HP/JA/KS, indicating backhaul quality issues.</div>
          <div class="action-box"><strong>Action</strong>Small cell NOC routing audit for Srinagar. Mobilisation SLA tightening. UBR RSL investigation on 6 degraded links.</div>
        </div>
      </div>
    </div>
  </div>

  <div class="domain-section">
    <div class="domain-section-hdr tower">🗼 Tower CM - DG Failure Continues (Best Zone, Still Only 25/100)</div>
    <div class="domain-section-body">
      <table class="mp-table">
        <tr><th>KPI</th><th>Srinagar</th><th>Target</th><th>Score</th></tr>
        <tr><td>eNodeB NWA</td><td>99.88%</td><td>≥99.99%</td><td><span class="tag-yellow">10 pts</span></td></tr>
        <tr><td>Infra Uptime</td><td>99.988%</td><td>≥99.999%</td><td><span class="tag-yellow">10 pts</span></td></tr>
        <tr><td>SA Alarms ≤4h</td><td>75%</td><td>100%</td><td><span class="tag-red">0 pts</span></td></tr>
        <tr><td>Non-SA ≤24h</td><td>96.1%</td><td>≥99%</td><td><span class="tag-yellow">5 pts</span></td></tr>
        <tr><td>DG Start</td><td>72.9%</td><td>100%</td><td><span class="tag-red">0 pts</span></td></tr>
        <tr><td><strong>TOTAL</strong></td><td colspan="2">Scope: 2,889 sites (largest in zone)</td><td><span class="tag-yellow"><strong>25/100</strong></span></td></tr>
      </table>
      <p style="font-size:12px;color:var(--sub);margin-top:8px">KS is best circle in zone at 25/100 - yet DG failure (72.9%) and SA alarm resolution (0 pts) are zone-wide structural problems affecting all circles.</p>
    </div>
  </div>

  <div class="domain-section">
    <div class="domain-section-hdr pm-mfl">🏗 Standalone PM - 0% TECO Srinagar (4 Sites)</div>
    <div class="domain-section-body">
      <div class="insight-card red">
        <div class="insight-card-body">
          <div class="insight-title">🚨 Srinagar: 4 Standalone Sites - 0 TECO Completed</div>
          <div class="exposure">4 Sites · 0% TECO · Feb Billing Non-Compliant</div>
          <div class="insight-text">All 4 Srinagar Standalone AG1 sites have WOs raised but no TECO executed. Joining HP (Kangra 2 sites, Shimla 6 sites) at 0% - three circles have completely unexecuted standalone TECO in Feb. This pattern suggests a systemic scheduling failure for this domain.</div>
          <div class="action-box"><strong>Immediate</strong>Schedule TECO for all 4 Srinagar standalone sites. Confirm physical visits and close in system.</div>
        </div>
      </div>
    </div>
  </div>

  <div class="domain-section">
    <div class="domain-section-hdr pm-tower">🗼 Tower PM - Highest Non-TECO Count in Zone</div>
    <div class="domain-section-body">
      <div class="insight-card orange">
        <div class="insight-card-body">
          <div class="insight-title">📊 2,642/2,889 TECO Done (91.4%) - 247 Sites Pending</div>
          <div class="exposure">247 Sites Not TECO'd · Largest Absolute in Zone</div>
          <div class="insight-text">With 2,889 tower sites (largest scope in zone), 247 unserviced sites represent the highest absolute non-TECO count. 163 non-TECO PM failures + 84 Zabbix visibility failures compound the monitoring gap seen in CM KPIs.</div>
          <div class="action-box"><strong>Action</strong>Scope-weighted PM execution plan. Resolve 84 Zabbix visibility failures centrally.</div>
        </div>
      </div>
    </div>
  </div>

  <div class="domain-section">
    <div class="domain-section-hdr pm-osc">📶 OSC PM - 52.9% (Better than UW, Still Below Target)</div>
    <div class="domain-section-body">
      <table class="mp-table">
        <tr><th>MP</th><th>Sites</th><th>Done</th><th>Completion</th><th>Status</th></tr>
        <tr><td>Srinagar</td><td>518</td><td>274</td><td>52.9%</td><td><span class="tag-orange">BELOW TARGET</span></td></tr>
      </table>
      <p style="font-size:12px;color:var(--sub)">244 OSC sites pending PM. While better than UW (34-46%), still significantly below expected completion. With small cell alarm response already worst in zone, unserviced sites may be contributing to availability failures.</p>
    </div>
  </div>
</div>

<!-- ===== UW PANEL ===== -->
<div class="circle-panel UW" id="panel-UW">
  <div class="circle-hdr UW">
    <div><h2>UW · UP West - Worst Issues Feb '26</h2>
    <div style="font-size:12px;opacity:.85;margin-top:4px">MPs: Agra · Aligarh · Bareilly · Bijnor · Etawah · Hapur · Meerut · Moradabad · Muzaffarnagar</div></div>
    <div class="score-badges">
      <div class="sbadge"><small>Hapur Tower CM</small>0/100 🔴</div>
      <div class="sbadge"><small>OSC PM ALL MPs</small>34-46% 🔴</div>
      <div class="sbadge"><small>Hapur SC Avail</small>78.9% 🔴</div>
      <div class="sbadge"><small>Muzaffarnagar Intra</small>39.9% miss</div>
      <div class="sbadge"><small>Agra MTTR</small>16h Intra</div>
    </div>
  </div>

  <div class="domain-section">
    <div class="domain-section-hdr pm-osc">📶 OSC PM - FULL CIRCLE CRISIS: ALL 9 MPs BELOW 46%</div>
    <div class="domain-section-body">
      <div class="insight-card red" style="margin-bottom:12px">
        <div class="insight-card-body">
          <div class="insight-title">🚨 UW OSC PM Systemic Failure - ~4,000 of 6,700 Sites Unserviced</div>
          <div class="exposure">Zone Avg 49% · UW Avg 41%</div>
          <div class="insight-text">Every single MP in UW circle has OSC PM completion below 46%. This is not an isolated failure - the entire UP West circle has systematically failed OSC PM execution in Feb. ~4,000 small cell sites across UW are unserviced, directly contributing to the catastrophic availability figures seen in OSC CM data.</div>
          <div class="action-box"><strong>Escalate to Circle Head</strong>OSC PM execution model for UW requires immediate review. Resource adequacy, WO execution process, and field verification to be audited.</div>
        </div>
      </div>
      <table class="mp-table">
        <tr><th>MP</th><th>Total Sites</th><th>PM Done</th><th>Completion</th><th>Status</th></tr>
        <tr><td><b>Hapur</b></td><td>508</td><td>174</td><td><b style="color:var(--red)">34.3%</b></td><td><span class="tag-red">WORST ZONE</span></td></tr>
        <tr><td><b>Meerut</b></td><td>307</td><td>120</td><td>39.1%</td><td><span class="tag-red">CRITICAL</span></td></tr>
        <tr><td><b>Etawah</b></td><td>679</td><td>267</td><td>39.3%</td><td><span class="tag-red">CRITICAL</span></td></tr>
        <tr><td><b>Bareilly</b></td><td>720</td><td>292</td><td>40.6%</td><td><span class="tag-red">CRITICAL</span></td></tr>
        <tr><td><b>Muzaffarnagar</b></td><td>635</td><td>259</td><td>40.8%</td><td><span class="tag-red">CRITICAL</span></td></tr>
        <tr><td><b>Agra</b></td><td>406</td><td>173</td><td>42.6%</td><td><span class="tag-red">CRITICAL</span></td></tr>
        <tr><td><b>Moradabad</b></td><td>667</td><td>286</td><td>42.9%</td><td><span class="tag-red">CRITICAL</span></td></tr>
        <tr><td><b>Aligarh</b></td><td>758</td><td>327</td><td>43.1%</td><td><span class="tag-red">CRITICAL</span></td></tr>
        <tr><td><b>Bijnor</b></td><td>443</td><td>201</td><td>45.4%</td><td><span class="tag-orange">CRITICAL</span></td></tr>
      </table>
    </div>
  </div>

  <div class="domain-section">
    <div class="domain-section-hdr tower">🗼 Tower CM - Hapur = 0/100 (Worst in Entire Zone)</div>
    <div class="domain-section-body">
      <table class="mp-table">
        <tr><th>MP</th><th>eNodeB NWA</th><th>Infra Uptime</th><th>SA ≤4h</th><th>Non-SA ≤24h</th><th>DG Start</th><th>Score</th></tr>
        <tr><td><b>Hapur</b></td><td>98.27% 🔴</td><td>99.66%</td><td>72%</td><td>84.2% 🔴</td><td>69%</td><td><span class="tag-red"><b>0/100</b></span></td></tr>
        <tr><td><b>Aligarh</b></td><td>99.64%</td><td>99.84%</td><td>80%</td><td>95.5%</td><td>63%</td><td><span class="tag-red">5/100</span></td></tr>
        <tr><td><b>Bareilly</b></td><td>99.70%</td><td>99.89%</td><td>75%</td><td>97.9%</td><td>66%</td><td><span class="tag-red">5/100</span></td></tr>
        <tr><td><b>Bijnor</b></td><td>99.59%</td><td>99.81%</td><td>74%</td><td>88.2% 🔴</td><td>63%</td><td><span class="tag-red">5/100</span></td></tr>
        <tr><td><b>Etawah</b></td><td>99.59%</td><td>99.80%</td><td>72%</td><td>90.9%</td><td>58%</td><td><span class="tag-red">5/100</span></td></tr>
        <tr><td><b>Muzaffarnagar</b></td><td>99.73%</td><td>99.93%</td><td>73%</td><td>96.9%</td><td>69%</td><td><span class="tag-red">5/100</span></td></tr>
        <tr><td><b>Agra</b></td><td>99.83%</td><td>99.95%</td><td>74%</td><td>99.7%</td><td>67%</td><td><span class="tag-orange">10/100</span></td></tr>
        <tr><td><b>Moradabad</b></td><td>99.69%</td><td>99.83%</td><td>75%</td><td>100% ✅</td><td>57%</td><td><span class="tag-orange">10/100</span></td></tr>
        <tr><td><b>Meerut</b></td><td>99.90%</td><td>99.96%</td><td>74%</td><td>99.8%</td><td>54%</td><td><span class="tag-yellow">30/100</span></td></tr>
      </table>
      <div class="insight-card red">
        <div class="insight-card-body">
          <div class="insight-title">🚨 Hapur Tower 0/100 - eNodeB NWA at 98.27%, Non-SA at 84.2%</div>
          <div class="exposure">1,194 Sites · Complete KPI Failure</div>
          <div class="insight-text">Hapur is only MP in zone scoring 0/100 on Tower CM. eNodeB NWA at 98.27% = 1.73% downtime (catastrophic vs 0.01% target). Non-SA alarm backlog at 84.2% means hundreds of unresolved chronic alarms. DG at 69% failure. Combined with OSC PM 34.3% and OSC small cell availability 78.9%, Hapur is in total multi-domain collapse.</div>
          <div class="action-box"><strong>Urgent - Multi-Domain Emergency</strong>Hapur requires immediate intervention across Tower CM, OSC CM, and OSC PM simultaneously. Escalate to zone head.</div>
        </div>
      </div>
    </div>
  </div>

  <div class="domain-section">
    <div class="domain-section-hdr osc">📶 OSC/Small Cell CM - Hapur Catastrophic, Bareilly Critical</div>
    <div class="domain-section-body">
      <table class="mp-table">
        <tr><th>MP</th><th>SC Availability</th><th>SA Alarms ≤4h</th><th>UBR Degraded</th><th>Status</th></tr>
        <tr><td><b>Hapur</b></td><td>78.89% 🔴</td><td>49%</td><td>3 cases</td><td><span class="tag-red">CATASTROPHIC</span></td></tr>
        <tr><td><b>Bareilly</b></td><td>87.86%</td><td>7% 🔴</td><td>1 case</td><td><span class="tag-red">CRITICAL</span></td></tr>
        <tr><td><b>Etawah</b></td><td>89.28%</td><td>18%</td><td>1 case</td><td><span class="tag-red">CRITICAL</span></td></tr>
        <tr><td><b>Aligarh</b></td><td>90.01%</td><td>21%</td><td>2 cases</td><td><span class="tag-red">CRITICAL</span></td></tr>
        <tr><td><b>Bijnor</b></td><td>92.34%</td><td>43%</td><td>1 case</td><td><span class="tag-red">FAIL</span></td></tr>
        <tr><td><b>Moradabad</b></td><td>94.0%</td><td>34%</td><td>0</td><td><span class="tag-red">FAIL</span></td></tr>
        <tr><td><b>Muzaffarnagar</b></td><td>93.84%</td><td>72%</td><td>3 cases</td><td><span class="tag-red">FAIL</span></td></tr>
        <tr><td><b>Agra</b></td><td>96.14%</td><td>59%</td><td>2 cases</td><td><span class="tag-orange">BELOW</span></td></tr>
        <tr><td><b>Meerut</b></td><td>98.27%</td><td>8% 🔴</td><td>0</td><td><span class="tag-orange">NEAR-MISS</span></td></tr>
      </table>
      <p style="font-size:12px;color:var(--sub);margin-top:8px">All UW MPs below 99.95% availability target. Hapur at 78.89% - 21pp gap. Bareilly and Meerut alarm resolution (7%, 8%) indicate NOC responsiveness failure.</p>
    </div>
  </div>

  <div class="domain-section">
    <div class="domain-section-hdr pm-fiber">📋 Fiber PM - Muzaffarnagar Crisis + Hapur Risk</div>
    <div class="domain-section-body">
      <table class="mp-table">
        <tr><th>MP</th><th>Billing Rate</th><th>NB KM</th><th>2X KM</th><th>Intra Miss</th><th>Status</th></tr>
        <tr><td><b>Muzaffarnagar</b></td><td>75.6%</td><td>734 KM</td><td>164 KM</td><td>39.9% <span class="tag-red">↑</span></td><td><span class="tag-red">CRISIS</span></td></tr>
        <tr><td><b>Hapur</b></td><td>80.0%</td><td>529 KM</td><td>213 KM</td><td>-</td><td><span class="tag-red">CRITICAL</span></td></tr>
        <tr><td><b>Agra</b></td><td>86.9%</td><td>290 KM</td><td>112 KM</td><td>19.2%</td><td><span class="tag-orange">WATCH</span></td></tr>
        <tr><td><b>Aligarh</b></td><td>87.6%</td><td>469 KM</td><td>160 KM</td><td>-</td><td><span class="tag-orange">WATCH</span></td></tr>
        <tr><td><b>Bareilly</b></td><td>97.3%</td><td>106 KM</td><td>-</td><td>-</td><td><span class="tag-green">BEST UW</span></td></tr>
      </table>
      <div class="insight-card red">
        <div class="insight-card-body">
          <div class="insight-title">📉 Muzaffarnagar Intra Miss 39.9% - Nearly Doubled from Dec (22.2%)</div>
          <div class="exposure">734 KM NB · 39.9% Intra Miss</div>
          <div class="insight-text">Muzaffarnagar intracity PM miss rate nearly doubled in one month: 22.2% (Dec) → 39.9% (Feb). 734 KM non-billable, 164 KM at 2X risk. This deterioration trend must be investigated - field execution breakdown likely.</div>
          <div class="action-box"><strong>Root Cause Required</strong>Patroller attendance audit + route-level execution check. Supervisor sign-off validation. Hapur (529 KM NB) also needs urgent attention.</div>
        </div>
      </div>
    </div>
  </div>

  <div class="domain-section">
    <div class="domain-section-hdr pm-tower">🗼 Tower PM - Hapur &amp; Bareilly Worst in Circle</div>
    <div class="domain-section-body">
      <table class="mp-table">
        <tr><th>MP</th><th>Scope</th><th>TECO Done</th><th>Completion</th><th>Non-TECO</th><th>Status</th></tr>
        <tr><td><b>Hapur</b></td><td>1,194</td><td>1,001</td><td>83.8%</td><td>97</td><td><span class="tag-red">WORST UW</span></td></tr>
        <tr><td><b>Bareilly</b></td><td>1,719</td><td>1,501</td><td>87.3%</td><td>176</td><td><span class="tag-red">CRITICAL</span></td></tr>
        <tr><td><b>Bijnor</b></td><td>951</td><td>862</td><td>90.6%</td><td>71</td><td><span class="tag-orange">BELOW</span></td></tr>
        <tr><td><b>Etawah</b></td><td>1,631</td><td>1,492</td><td>91.5%</td><td>95</td><td><span class="tag-orange">BELOW</span></td></tr>
        <tr><td><b>Meerut</b></td><td>1,102</td><td>1,084</td><td>98.4%</td><td>3</td><td><span class="tag-green">BEST UW</span></td></tr>
      </table>
      <p style="font-size:12px;color:var(--sub)">Hapur (83.8%) and Bareilly (87.3%) are the two worst Tower PM performers in UW. Hapur's multi-domain failure (Tower CM 0/100, OSC PM 34.3%, Tower PM 83.8%) makes it the single most distressed MP in the zone.</p>
    </div>
  </div>

  <div class="domain-section">
    <div class="domain-section-hdr fiber">📡 Fiber CM - Agra MTTR &amp; Hapur KPI</div>
    <div class="domain-section-body">
      <div class="insight-grid">
        <div class="insight-card red">
          <div class="insight-card-body">
            <div class="insight-title">⏱ Agra MTTR = 12h Inter / 16h Intra - Worst Zone</div>
            <div class="exposure">16h Average Restoration Time</div>
            <div class="insight-text">Agra has worst MTTR in zone at 16h intracity. Fiber CM KPI: Intercity=20/100, Intracity=10/100. Slow restoration is compounded by spares shortage and mobilisation delays. Network reliability severely impacted.</div>
            <div class="action-box"><strong>Action</strong>Spares positioning audit. MTTR event deep-dive. On-call roster verification for Agra.</div>
          </div>
        </div>
        <div class="insight-card orange">
          <div class="insight-card-body">
            <div class="insight-title">📡 Hapur Fiber CM 5/100 - Completes Multi-Domain Failure</div>
            <div class="exposure">Fiber CM 5 · Tower CM 0 · OSC PM 34%</div>
            <div class="insight-text">Hapur scores 5/100 on intercity Fiber CM (3rd worst in zone), Tower CM 0/100 (worst zone), OSC PM 34.3% (worst zone), and Tower PM 83.8% (worst UW). This is the most distressed MP in the entire zone across all domains.</div>
            <div class="action-box"><strong>Zone Head Escalation</strong>Hapur needs dedicated multi-domain intervention task force. Single-MP emergency action plan required.</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


</div>

<div class="footer">
  COO Operations Intelligence · Feb '26 · Domains: Fiber CM/PM · Tower CM/PM (21,129 sites) · OSC/Small Cell CM/PM (7,215 sites) · MFL CM/PM (308 sites) · Standalone CM/PM (62 sites) · FTTX OLT/PM<br>
  Sources: Fiber KPI SLA · Tower KPI SLA (xlsb) · OSC KPI SLA · MFL + Standalone Backup · FTTX OLT + PM · Fiber PM Penalty Dashboard · PM Final Scope · Patrolling Data<br>
  ⚠️ Manpower availability (FRT/Labour/Vehicle) data not yet received for Feb'26 - section will be added once provided
</div>

<script>
function setTab(c){
  document.querySelectorAll('.circle-tab').forEach(t=>t.classList.remove('active'));
  document.querySelectorAll('.circle-panel').forEach(p=>p.classList.remove('active'));
  document.querySelector('.circle-tab.'+c).classList.add('active');
  document.getElementById('panel-'+c).classList.add('active');
}
</script>
</body>
</html>`;
